import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * LanguageAwareWrapper Component
 * Wraps components to ensure they re-render when language changes
 * This solves the issue where components don't update when language is switched
 */
const LanguageAwareWrapper = ({ children }) => {
  const { i18n } = useTranslation();
  const [key, setKey] = useState(0);

  useEffect(() => {
    const handleLanguageChange = () => {
      // Force re-render by changing the key
      setKey(prev => prev + 1);
    };

    const handleCustomLanguageChange = (event) => {
      const { language } = event.detail;
      if (language !== i18n.language) {
        handleLanguageChange();
      }
    };

    const handleStorageChange = () => {
      const storedLanguage = localStorage.getItem('I18N_LANGUAGE');
      if (storedLanguage && storedLanguage !== i18n.language) {
        handleLanguageChange();
      }
    };

    // Listen for language changes from i18n
    i18n.on('languageChanged', handleLanguageChange);

    // Listen for custom language change events
    window.addEventListener('languageChanged', handleCustomLanguageChange);

    // Listen for storage changes
    window.addEventListener('storage', handleStorageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
      window.removeEventListener('languageChanged', handleCustomLanguageChange);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [i18n]);

  return <div key={key}>{children}</div>;
};

export default LanguageAwareWrapper; 